export const hashtagRegex = /(\s|^)#(\p{L}|\d|_)+/gmu;
